<script setup>
import Commons from '@/shared/utils/commons'
import Copy from '@/shared/utils/copy'
import TableList from '../others/TableList.vue'
import SlideDetailView from '../others/SlideDetailView.vue'
import PackageDetails from '../packages/PackageDetails.vue'
import statuses from '../packages/statuses.json'
import { ref, onMounted } from 'vue'

const cols = [
  {
    name: 'Colis',
    id: 'id',
    value(el) {
      const id = el?.id || '-'
      const reference = el?.reference || ''
      const truncated = id.length > 16 ? `${id.substring(0, 8)}...${id.substring(id.length - 8)}` : id
      return `
        <div class="flex items-center gap-2">
          <div class="flex flex-col">
            <span class="font-mono text-xs font-semibold">${reference || '#' + truncated.substring(0, 8)}</span>
            <div class="flex items-center gap-1">
              <span class="font-mono text-xs text-gray-500">${truncated}</span>
            </div>
          </div>
          <button onclick="window.copyToClipboard('${id}')" class="p-1 hover:bg-gray-100 rounded" title="Copier l'ID">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </button>
        </div>
      `
    },
  },
  {
    id: 'orderDate',
    name: 'Date',
    value(el) {
      return Commons.time(el?.orderDate)
    },
  },
  {
    id: 'status',
    name: 'Statut',
    filter: {
      key: 'status',
      default: '',
      options: [
        { name: 'Tout', value: '' },
        { name: 'Nouveau', value: 'created' },
        { name: 'En attente', value: 'pending' },
        { name: 'Confirmé', value: 'confirmed' },
        { name: 'Récupéré', value: 'picked_up' },
        { name: 'En transit', value: 'in_transit' },
        { name: 'Livré', value: 'delivered' },
        { name: 'Annulé', value: 'cancelled' },
      ],
    },
    value(el) {
      const status = statuses[el?.status] || { name: el?.status || 'Inconnu', background: '#6B7280', color: '#FFFFFF' }
      return `<div style="background-color: ${status.background}; color: ${status.color}" class="inline-block px-4 py-1 rounded-full font-semibold text-sm">${status.name}</div>`
    },
  },
  {
    name: 'Expéditeur',
    value(el) {
      return el?.customerName || '-'
    },
  },
  // {
  //   name: 'Destinataire',
  //   value(el) {
  //     const recipient = el?.recipientName || el?.destinationAddress || '-'
  //     return recipient.length > 30 ? `${recipient.substring(0, 27)}...` : recipient
  //   },
  // },
  {
    name: 'Type',
    value(el) {
      const types = {
        'document': 'Document',
        'parcel': 'Colis',
        'food': 'Alimentaire',
        'fragile': 'Fragile',
        'other': 'Autre',
      }
      return types[el?.packageType] || el?.packageType || '-'
    },
  },
  {
    name: 'Véhicule',
    value(el) {
      const vehicles = {
        'moto': 'Moto',
        'car': 'Voiture',
        'motorcross': 'Motorcross',
      }
      return vehicles[el?.deliveryType] || el?.deliveryType || '-'
    },
  },
  {
    name: 'Livreur',
    value(el) {
      return el?.riderName || 'Non assigné'
    },
  },
  {
    id: 'totalPrice',
    name: 'Total',
    value(el) {
      const price = el?.pricing?.total ?? el?.totalPrice ?? 0
      return Commons.formatNumber(price, { suffix: ' FCFA' })
    },
  },
  // {
  //   name: 'Frais livraison',
  //   value(el) {
  //     const deliveryFee = el?.pricing?.deliveryFee ?? el?.deliveryFee ?? 0
  //     return Commons.formatNumber(deliveryFee, { suffix: ' FCFA' })
  //   },
  // },
  // {
  //   name: 'Frais service',
  //   value(el) {
  //     const serviceFee = el?.pricing?.serviceFee ?? el?.serviceFee ?? 0
  //     return Commons.formatNumber(serviceFee, { suffix: ' FCFA' })
  //   },
  // },
  {
    name: 'Distance',
    value(el) {
      const distance = el?.distanceKm ?? 0
      return `${distance} km`
    },
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/eye.png',
    onClick(el) {
      detailData.value = el
    },
    value() {},
  },
]

const detailData = ref(null)

onMounted(() => {
  window.copyToClipboard = (text) => {
    Copy.toClipboard(text, 'ID copié')
  }
})
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <TableList
      title="Colis"
      dataKey="packages"
      hasSearch
      :cols="cols"
    ></TableList>
  </div>
  <SlideDetailView :isVisible="!!detailData" @hide="detailData = null">
    <PackageDetails :packageData="detailData"></PackageDetails>
  </SlideDetailView>
</template>